import React from 'react';

// Trigger deployment for CSP fix
// Trigger deployment for showcase images
const PuppyDogPlayer: React.FC = () => {
  return (
    <section className="py-20 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-brand-secondary mb-4">
            Experience CanvasEstate
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Take a quick tour of our platform and see how easy it is to manage your property portfolio.
          </p>
        </div>

        <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-gray-100">
          <div
            id="puppydog-embed-demo"
            style={{
              position: 'relative',
              paddingBottom: '56.25%', // Standard 16:9 ratio for better integration
              height: 0,
              width: '100%'
            }}
          >
            <iframe
              src="https://player.puppydog.io/play/q0lefa"
              title="PuppyDog Video Player"
              frameBorder="0"
              loading="lazy"
              allowFullScreen
              allow="clipboard-write"
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: '1px solid #E9E9E9',
                borderRadius: '15px',
                overflow: 'hidden'
              }}
            >
            </iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PuppyDogPlayer;
